import { NoticeDTO } from '../../models/dto/NotificationDTO';
import { AppEnum } from '../../models/enum/AppEnum';
import { api } from '../../services/api';

export const chartActionsTypes = {
  GET_CHART_DATA: 'GET_CHART_DATA',
  GET_CHART_DATA_SUCCESS: 'GET_CHART_DATA_SUCCESS',
  GET_CHART_DATA_FAILURE: 'GET_CHART_DATA_FAILURE',

  CHANGE_CONDOMINIUM: 'CHANGE_CONDOMINIUM',
};

export const getNotificationsByPeriod = async (
  reference: number,
  dateFrom: string,
  dateTo: string,
): Promise<NoticeDTO[]> => {
  try {
    const { data } = await api.get<NoticeDTO[]>(`/notifications/info`, {
      params: {
        reference,
        createdDateFrom: dateFrom,
        createdDateTo: dateTo,
        type: AppEnum.APP_REKOGNIT.description,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const setReadOrUnreadNotification = async (
  notificationId: number,
  visualizedAt: string,
) => {
  try {
    await api.put(`/notifications/info/visualized`, {
      id: notificationId,
      flagVisualized: visualizedAt.length > 0,
    });
  } catch (error) {
    console.log(error);
  }
};
